export const seamhead = [
  {
    number: 'MC084',
    hasModel: false,
  },
  {
    number: 'MC085',
    hasModel: false,
  },
  {
    number: 'MC086',
    hasModel: false,
  },
  {
    number: 'MC087',
    hasModel: false,
  },
  {
    number: 'MC088',
    hasModel: false,
  },
  {
    number: 'MC089',
    hasModel: false,
  },
  {
    number: 'MC090',
    hasModel: false,
  },
  {
    number: 'MC091',
    hasModel: false,
  },
  {
    number: 'MC093',
    hasModel: false,
  },
  {
    number: 'MC094',
    hasModel: false,
  },
  {
    number: 'MC095',
    hasModel: false,
  },
  {
    number: 'MC096',
    hasModel: false,
  },
  {
    number: 'MC097',
    hasModel: false,
  },
  {
    number: 'MC098',
    hasModel: false,
  },
  {
    number: 'MC099',
    hasModel: false,
  },
  {
    number: 'MC100',
    hasModel: false,
  },
  {
    number: 'MC101',
    hasModel: false,
  },
  {
    number: 'MC102',
    hasModel: false,
  },
  {
    number: 'MC103',
    hasModel: false,
  },
  {
    number: 'MC104',
    hasModel: false,
  },
  {
    number: 'MC105',
    hasModel: false,
  },
  {
    number: 'MC106',
    hasModel: false,
  },
  {
    number: 'MC107',
    hasModel: false,
  },
  {
    number: 'MC108',
    hasModel: false,
  },
  {
    number: 'MC109',
    hasModel: false,
  },
  {
    number: 'MC110',
    hasModel: false,
  },
  {
    number: 'MC111',
    hasModel: false,
  },
  {
    number: 'MC112',
    hasModel: false,
  },
  {
    number: 'MC113',
    hasModel: false,
  },
  {
    number: 'MC114',
    hasModel: false,
  },
  {
    number: 'MC115',
    hasModel: false,
  },
  {
    number: 'MC116',
    hasModel: false,
  },
  {
    number: 'MC117',
    hasModel: false,
  },
  {
    number: 'MC118',
    hasModel: false,
  },
  {
    number: 'MC120',
    hasModel: false,
  },
  {
    number: 'MC121',
    hasModel: false,
  },
  {
    number: 'MC122',
    hasModel: false,
  },
  {
    number: 'MC123',
    hasModel: false,
  },
  {
    number: 'MC124',
    hasModel: false,
  },
  {
    number: 'MC125',
    hasModel: false,
  }
];